module.exports = __webpack_public_path__ + "public/img/ico-status-lifecycle.6a3b856f.svg";